<template>
  <div v-if="currentOffre">
    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Recrutements'"
          :description="'Modification d\'un recrutement'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4" v-if="currentOffre.document">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 text-custom-primary">
                    Référence :
                    {{ currentOffre.document.reference }}
                  </td>
                  <td class="col-6">
                    Statut :
                    <i
                      class="mdi mdi-checkbox-blank-circle mr-1"
                      :class="{
                        'text-success': currentOffre.statut === 0,
                        'text-danger': currentOffre.statut === 1,
                      }"
                    ></i>
                    {{ getStatutOE(currentOffre.statut) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="
            $router.push({ name: 'rh_offre_emploi' }).catch(() => {})
          "
        >
          Liste des recrutements
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router.push({ name: 'rh_offre_emploi-create' }).catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouveau recrutement
        </button>
        <button
          type="button"
          class="btn btn-custom-primary"
          @click.prevent="
            $router
              .push({
                name: 'rh_offre_emploi-show',
                params: { id: currentOffre.id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-eye font-size-17"></i> Aperçu
        </button>
      </div>
      <div class="col-md-12 col-lg-6">
        <b-button
          variant="danger"
          class="btn-icon mr-4"
          @click="cloturer"
          v-if="currentOffre.statut === 0"
        >
          <span class="btn-icon-label">
            <i class="fas fa-lock"></i>
          </span>
          Clôturer
        </b-button>
        <b-button
          variant="warning"
          class="btn-icon"
          @click="reinitialiser"
          v-if="currentOffre.statut === 1"
        >
          <span class="btn-icon-label">
            <i class="fas fa-hourglass"></i>
          </span>
          Réinitialiser
        </b-button>
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{
                name: 'rh_offre_emploi-edit',
                params: { id: currentOffre.id },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-edit text-custom-primary font-size-17"></i> Offre
              d'emploi</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'rh_offre_emploi_edit-document',
                params: {
                  id: currentOffre.id,
                  documentUuid: currentOffre.document.uuid,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-paperclip text-custom-primary font-size-17"></i>
              Documents</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'rh_offre_emploi_edit-candidature',
                params: { id: currentOffre.id },
              }"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Candidatures</b-nav-item
            >
          </b-nav>
        </div>
      </div>

      <div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import URL from '@/http/rh/offre-emploi';
export default {
  data() {
    return {
      title: 'Gestion des recrutements - Edition',
    };
  },
  computed: {
    ...mapGetters('offreEmploi', [
      'currentOffre',
      'postes',
      'naturePostes',
      'contratTypes',
    ]),
  },

  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    ...mapActions('offreEmploi', [
      'setCurrentOffre',
      'setPostes',
      'setNaturePostes',
      'setContratTypes',
    ]),
    init() {
      this.setPostes([]);
      this.setNaturePostes([]);
      this.setContratTypes([]);
      this.setCurrentOffre(null);

      window.axios
        .all([
          window.axios.get(URL.GET_REQUIREMENTS),
          window.axios.get(URL.OFFRE_EMPLOI + '/' + this.$route.params.id, {
            params: {
              edit: true,
            },
          }),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.setCurrentOffre(resp2.data.offre_emploi);
            this.setPostes(resp1.data.postes);
            this.setNaturePostes(resp1.data.nature_postes);
            this.setContratTypes(resp1.data.contrat_types);
          })
        )
        .catch();
    },

    onChangeStatut() {
      this.$router
        .push({
          name: 'rh_offre_emploi-show',
          params: { id: this.currentOffre.id },
        })
        .catch(() => {});
    },
    cloturer() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.CLOTURER + '/' + this.$route.params.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.onChangeStatut();
            })
            .catch();
        }
      });
    },
    reinitialiser() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.REINITIALISER + '/' + this.$route.params.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.onChangeStatut();
            })
            .catch();
        }
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
